import React from 'react';
import { Link } from 'react-router-dom';

const imgRectangle = '/assets/auth/rectangle-bg.png';
const imgVector = '/assets/auth/vector-overlay.svg';
const imgLogo = '/assets/auth/good-outcomes-logo.svg';

export function BrandMark() {
  return (
    <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-go-primary">
      <svg className="h-8 w-8" fill="none" viewBox="0 0 62 62">
        <g clipPath="url(#clip0_brand_mark)">
          <path
            d="M47.5807 0H14.4193C6.45575 0 0 6.45575 0 14.4193V47.5807C0 55.5443 6.45575 62 14.4193 62H47.5807C55.5443 62 62 55.5443 62 47.5807V14.4193C62 6.45575 55.5443 0 47.5807 0Z"
            fill="#4342FF"
          />
          <path
            d="M30.428 50.4676C25.7751 50.4676 21.199 48.7554 17.6748 45.5306C17.0529 44.9625 17.0068 43.9874 17.575 43.3654C18.1432 42.7435 19.1183 42.6975 19.7402 43.2656C23.9247 47.0893 29.8828 48.3792 35.2805 46.6363C36.0867 46.3752 36.9543 46.8206 37.2077 47.6267C37.4687 48.4329 37.0234 49.2929 36.2172 49.5539C34.3207 50.1682 32.3628 50.4676 30.4203 50.4676H30.428Z"
            fill="white"
          />
          <path
            d="M30.4894 41.1695C27.1264 41.1695 23.8249 39.9871 21.2067 37.7759C16.001 33.3533 14.5268 26.804 17.3523 20.6846C19.8477 15.2946 25.9747 10.4421 34.0367 11.7704C37.0004 12.2541 40.133 13.6515 42.8741 15.6939C43.519 16.1776 44.7475 17.3063 45.4232 17.9359C45.7917 18.2814 46.0144 18.7728 46.022 19.2795C46.0297 19.7863 45.8301 20.293 45.4692 20.6539L43.4806 22.6502C44.0027 24.6157 44.8627 28.8463 43.6419 32.1632C42.0679 36.4245 38.6128 39.5418 34.1595 40.7089C32.9464 41.0237 31.7179 41.1849 30.4971 41.1849L30.4894 41.1695ZM23.1953 35.4341C25.9978 37.8142 29.8061 38.6665 33.3763 37.7298C36.8545 36.8161 39.5418 34.3975 40.7626 31.0883C41.6072 28.7926 41.0697 25.2069 40.348 22.8421C40.1484 22.1741 40.325 21.4524 40.824 20.961L42.4364 19.3486C41.7991 18.7728 41.3077 18.3428 41.039 18.1432C38.7279 16.4156 35.9945 15.1948 33.5453 14.7879C27.0727 13.7283 22.1511 17.6287 20.1394 21.9668C18.3889 25.7444 18.2814 31.2649 23.1876 35.4341H23.1953Z"
            fill="white"
          />
          <path
            d="M43.1198 46.5134C44.7396 46.5134 46.0528 45.2003 46.0528 43.5804C46.0528 41.9606 44.7396 40.6474 43.1198 40.6474C41.4999 40.6474 40.1867 41.9606 40.1867 43.5804C40.1867 45.2003 41.4999 46.5134 43.1198 46.5134Z"
            fill="#97FAFF"
          />
        </g>
        <defs>
          <clipPath id="clip0_brand_mark">
            <rect width="62" height="62" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

interface AuthBrandPanelProps {
  highlights?: string[];
}

export function AuthBrandPanel({ highlights = [] }: AuthBrandPanelProps) {
  return (
    <div className="relative hidden overflow-hidden bg-go-primary lg:flex lg:w-1/2">
      <div className="absolute inset-0">
        <img
          alt=""
          className="absolute left-0 h-full w-full object-cover opacity-20"
          src={imgRectangle}
        />
      </div>

      <div className="absolute inset-y-0 right-0 w-px bg-white/10" />

      <div className="absolute inset-0 flex items-center justify-center opacity-[0.08]">
        <div className="h-[524px] w-[482px] scale-y-[-1]">
          <img alt="" className="block h-full w-full object-contain" src={imgVector} />
        </div>
      </div>

      <div className="relative z-10 flex flex-col justify-center px-12 text-white">
        <div className="mb-12">
          <Link to="/" className="block h-[41px] w-[156px] scale-y-[-1]">
            <img
              alt="Good Outcomes logo"
              className="block h-full w-full object-contain"
              src={imgLogo}
            />
          </Link>
        </div>

        <div className="max-w-xl space-y-6">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-white/80">
            Conduct intelligence
          </p>
          <h1 className="text-4xl font-semibold leading-tight tracking-tight xl:text-5xl">
            See what's happening. Act before it escalates.
          </h1>
          <p className="text-lg leading-8 text-white/90">
            Good Outcomes brings customer conversations into one place, interprets them
            through a regulatory lens, and gives teams clearer guidance and evidence.
          </p>
        </div>

        {highlights.length > 0 && (
          <div className="mt-10 space-y-4">
            {highlights.map((highlight) => (
              <div key={highlight} className="text-base leading-7 text-white/90">
                {highlight}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
